import React from 'react';
import { Flex, Text, Box } from '@chakra-ui/react';
import { TAB_STATUSES } from 'api/administrador/refunds';

export default function RefundTabs({ activeTab, counts, onChange }) {
  return (
    <Flex borderBottom="1px solid" borderColor="gray.200" px={6} gap={8} flexWrap="wrap">
      {TAB_STATUSES.map((tab) => {
        const isActive = activeTab === tab.key;
        const count = counts?.[tab.key] ?? 0;

        return (
          <Box
            key={tab.key}
            as="button"
            type="button"
            py={4}
            borderBottom={isActive ? '3px solid #574feb' : '3px solid transparent'}
            color={isActive ? '#574feb' : 'gray.500'}
            fontWeight={isActive ? 'bold' : 'medium'}
            onClick={() => onChange(tab.key)}
            _focus={{ outline: 'none' }}
            _hover={{ color: isActive ? '#574feb' : 'gray.700' }}
          >
            <Flex align="center" gap={2}>
              <Text fontSize="sm">{tab.label}</Text>
              <Flex
                align="center"
                justify="center"
                px={2.5}
                py={0.5}
                minH="20px"
                borderRadius="full"
                bg={isActive ? '#574feb' : 'gray.100'}
                color={isActive ? 'white' : 'gray.600'}
                fontSize="xs"
                fontWeight="semibold"
                lineHeight="1"
              >
                {count}
              </Flex>
            </Flex>
          </Box>
        );
      })}
    </Flex>
  );
}
